<template>
  <div class="row" v-if="(nfs) && (nfs.length)">
    <div class="col-md-12">
      <div style="border: 1px solid #EBEDF3; border-radius: 0.42rem; padding: 16px;">
        <h3 class="card-label" style="margin-bottom: 1.75rem;">NFs</h3>
        <b-table v-if="!loading" striped hover :items="nfs" :fields="fields">
        </b-table>
        <Loading v-if="loading" :modoPR="pagRec" tamanho="100px" />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "NFsFluxo",
  props: ["nfs", "loading", "pagRec"],
  data() {
    return {
      fields: [
        {
          key: 'NF',
          label: 'Nº NF',
          sortable: true,
          formatter: (value) => {
            if(value) {
              return value;
            } else {
              return 'Sem número';
            }
          }
        },
        {
          key: 'VALOR',
          label: 'Valor',
          sortable: true,
          formatter: (value) => {
            return value.toLocaleString('pt-br', {
              style: 'currency', 
              currency: 'BRL'
            });
          }
        },
        {
          key: 'DATA_INCLUSAO',
          label: 'Data Inclusão',
          sortable: true,
          formatter: (value) => {
            return moment(value, "YYYYMMDD[T]HHmmss").format("DD/MM/YYYY [às] HH:mm:ss");
          }
        }
      ]
    };
  }
}
</script>

<style scoped>

</style>